export const IDEAS_CREATE_IDEA = "ideas-create-idea";
export const IDEAS_PREVIEW_LIST = "ideas-preview-list";
export const IDEAS_PREVIEW_ACCEPTED = "ideas-preview-accepted";
export const IDEAS_PREVIEW_DISCARDED = "ideas-preview-discarded";
export const IDEAS_PREVIEW_ACCEPT_ALL = "ideas-preview-accept-all";
export const IDEAS_PREVIEW_DISCARD_ALL = "ideas-preview-discard-all";
export const IDEAS_AI_FAIL = "Ideas-AI-fail";

export const IDEAS_CREATE_POST_ADD = "ideas-create-post-add";
export const IDEAS_PIN_IDEA = "ideas-pin-idea";
export const IDEAS_SIGN_OFF = "ideas-sign-off";
export const IDEAS_ADD_ASSIGNEE = "ideas-add-assignee";
export const IDEAS_ADD_DATE = "ideas-add-date";
export const IDEAS_ADD_LABEL = "ideas-add-label";
export const IDEAS_ADD_CHANNEL = "ideas-add-channel";
export const IDEAS_ARCHIVE_IDEA = "ideas-archive-idea";
export const IDEAS_DISCARD_IDEA = "ideas-discard-idea";
export const IDEAS_VISIBLE_FOR_REVIEW = "ideas-visible-for-review";
export const IDEAS_MOVED_SWIMLANE = "ideas-moved-swimlane";
export const IDEAS_SEND_COMMENT = "ideas-send-comment";
export const IDEAS_AI_GENERATE = "ideas-AI-generate";

export const IDEAS_CREATE_POST = "ideas-create-post";
export const IDEAS_BULK_CREATE = "ideas-bulk-create";

export const BRANDKIT_DESCRIPTION_SAVED = "brandkit-description-saved";
export const BRANDKIT_DESCRIPTION_EDITED = "brandkit-description-edited";
export const BRANDKIT_DESCRIPTION_GENERATION_FAILED =
  "brandkit-description-generation-failed";
export const BRANDKIT_TOV_SAVED = "brandkit-tov-saved";
export const BRANDKIT_TOV_GENERATION_FAILED = "brandkit-tov-generation-failed";
export const BRANDKIT_CUSTOM_INSTRUCTION_SAVED =
  "brandkit-custom-instruction-saved";
